import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Error404 from './containers/errors/Error404';
import Home from './containers/pages/Home';
import About from './containers/pages/About';
import Services from './containers/pages/Services';
import Portfolio from './containers/pages/Portfolio';
import Contact from './containers/pages/Contact';
import CookiesPolicies from './containers/policies/CookiesPolicies';
import PrivacyPolicies from './containers/policies/PrivacyPolicies';
import PurchasingPolicies from './containers/policies/PurchasingPolicies';
import WebDesign from './containers/services/WebDesign';
import Branding from './containers/services/Branding';
import DigitalMarketing from './containers/services/DigitalMarketing';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<Services />} />
        <Route path="/servicios/web" element={<WebDesign />} />
        <Route path="/servicios/branding" element={<Branding />} />
        <Route path="/servicios/marketing" element={<DigitalMarketing />} />
        <Route path="/proyectos" element={<Portfolio />} />
        <Route path="/nosotros" element={<About />} />
        <Route path="/contacto" element={<Contact />} />
        {/* Compatibilidad con las URLs antiguas ya publicadas */}
        <Route path="/services" element={<Navigate to="/servicios" replace />} />
        <Route path="/services/web-design" element={<Navigate to="/servicios/web" replace />} />
        <Route path="/services/graphic-design" element={<Navigate to="/servicios/branding" replace />} />
        <Route path="/services/digital-marketing" element={<Navigate to="/servicios/marketing" replace />} />
        <Route path="/portfolio" element={<Navigate to="/proyectos" replace />} />
        <Route path="/about" element={<Navigate to="/nosotros" replace />} />
        <Route path="/cookies-policies" element={<CookiesPolicies />} />
        <Route path="/privacy-policies" element={<PrivacyPolicies />} />
        <Route path="/purchasing-policies" element={<PurchasingPolicies />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}
